<template>
  <section v-if="Refreshment && lang[2]">
    <Title :title-name="title.Refreshment.titleName" :title-link="title.Refreshment.titleLink" />
    <div v-if="airline.meal_enabled" class="refreshment">
      <div class="container">
        <div style="margin: 14pt 0">
          <div>{{ lang[2].SFS_LANG_ROW_3 }} <br /></div>
        </div>
        <div
          v-if="airline && airline.template_config && airline.template_config.logo_meanplanservice"
          class="d-flex align-items-center"
        >
          <span v-if="iconRefreshment" class="fa-stack icon-refreshment">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fa-stack-1x fa-inverse fas fa-concierge-bell icon-concierge-bell"></i>
          </span>
          <img
            style="width: 60px"
            class="mr-4"
            :src="airline.template_config.logo_meanplanservice"
            :class="iconRefreshment ? 'd-none' : ''"
            @error="iconRefreshment = true"
          />
          <h2 class="title d-inline-block">{{ lang['homepage_new'].SFS_LANG_ROW_21 }}</h2>
        </div>
        <div v-else class="d-flex align-items-center">
          <h2 class="title sb_mobile sb_refreshment" style="padding-left: 45pt"></h2>
          <h2 class="title d-inline-block">{{ lang['homepage_new'].SFS_LANG_ROW_21 }}</h2>
        </div>
        <div
          v-html="
            replaceStr(lang[2].SFS_LANG_ROW_4, ['<amount>', '<currency>'], [Refreshment.price_per_person, Refreshment.currency])
          "
        ></div>
        <div>
          <div
            v-if="
              airline.airline_config_pos.enable_vcn_voucher_text &&
              airline.airport_config_pos.enable_show_info &&
              airline.airport_config_pos.mobile_refreshment
            "
          >
            {{ airline.airline_config_pos.text }}
          </div>
          <div
            v-if="
              airline.airline_config_pos.enable_vcn_voucher_image &&
              airline.airport_config_pos.enable_show_info &&
              airline.airport_config_pos.mobile_refreshment
            "
            class="mb-2"
          >
            <img style="width: 300px; height: auto" :src="airline.airline_config_pos.image_url" />
          </div>
        </div>
        <CreditCard :amount="Refreshment.price_per_person || 0"></CreditCard>
        <div style="margin: 14pt 0">
          <div>
            {{ lang[2].SFS_LANG_ROW_5 }} <br />
            {{ lang[2].SFS_LANG_ROW_6 }} <br />
            {{ lang[2].SFS_LANG_ROW_7 }}
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container">
        <div style="margin: 14pt 0">
          <p>{{ lang[2].SFS_LANG_ROW_9 }}</p>
        </div>
      </div>
    </div>
    <div v-if="airline.meal_enabled" class="block-item">
      <div class="container">
        <router-link
          style="display: block; padding: 10pt 0; text-transform: uppercase"
          :to="{ name: 'VirtualCreditCardDetail', query: { secret: secret, service_id: 2 } }"
        >
          <div>
            <AboutCreditCard></AboutCreditCard>
          </div>
        </router-link>
      </div>
    </div>
    <ButtonDownloadVoucher
      v-if="airline.meal_enabled"
      :name-voucher="nameVoucher"
      :can-download="canDownload"
    ></ButtonDownloadVoucher>
  </section>
</template>

<script>
import CreditCard from '@/components/CreditCard/index'
import AboutCreditCard from '@/components/AboutCreditCard/index'
import ButtonDownloadVoucher from '@/components/ButtonDownloadVoucher/index'
import { replaceStr } from '@/utils/helper'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'

export default {
  name: 'Refreshment',
  components: { CreditCard, AboutCreditCard, Title, ButtonDownloadVoucher },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nameVoucher: 'Refreshment',
      canDownload: false,
      iconRefreshment: false
    }
  },
  computed: {
    ...mapGetters({
      Refreshment: 'Refreshment/Refreshment'
    })
  },
  watch: {
    Refreshment: function (newVal) {
      this.canDownload = newVal && newVal.currency != '' ? true : false
    },
    airline: function (value) {
      if (!_.isEmpty(value.photo2claim) && value.photo2claim.enable) {
        this.$router.push({ path: '/photo-pay', query: { secret: this.secret, refreshmentId: this.$route.query.refreshmentId } })
      }
    }
  },
  created() {
    if (!_.isEmpty(this.airline) && this.airline.params.photo2claim.enable) {
      this.$router.push({ path: '/photo-pay', query: { secret: this.secret, refreshmentId: this.$route.query.refreshmentId } })
    }
    this.$store.dispatch('Refreshment/getRefreshment')
  },
  methods: {
    replaceStr
  }
}
</script>

<style lang="scss" scoped>
.icon-refreshment {
  font-size: 24px;
  color: #f5b945;
  .icon-concierge-bell {
    font-size: 30px;
  }
}
</style>
